import store from '@/store';
import { COUNTRY } from '@/core/country';
import { cleanDocument as cleanDocumentAU } from '@/core/clean-document/au';
import { cleanDocument as cleanDocumentUK } from '@/core/clean-document/uk';

/**
 * This function is to clean up unused fields from the document
 * before saving occurs.
 * @param document
 */
export function cleanDocument(document) {
  const countryCode = store.state.onboarding?.countryCode;
  let clearDocument;
  switch (countryCode) {
    case COUNTRY.AU:
      clearDocument = cleanDocumentAU;
      break;
    case COUNTRY.GB:
      clearDocument = cleanDocumentUK;
      break;
    default:
      return document;
  }
  return clearDocument(document);
}
